<script setup>

const props = defineProps({
    percent: {
        type: Number,
        required: true
    },
    color: {
      type: String,
      default: 'green'
    },
    over: {
      type: String,
      default: 'false'
    } 
})

</script>

<template>
    <div v-if="percent < 100" class="progress-circle" :style="[{'color': `var(--${color})`}]">
      <span class="font_text_Arial_BoldMT progress-circle-percent">{{percent}}%</span>
      <svg viewBox="0 0 120 120" class="progress-circle-svg">
        <circle
          cx="60"
          cy="0"
          r="54"
          fill="none"
          stroke="#4e4e4e"
          
          stroke-width="6" />
        
        <circle
          class="progress-circle-line"
          :style="[{'stroke-dashoffset': `calc(100 - ${percent/2})`}]"
          cx="60"
          cy="0"
          r="54"
          fill="none"
          :stroke="`var(--${color})`"
          stroke-width="6"
          pathLength="100" />
      </svg>
    </div>
    <div v-if="percent >= 100" class="progress-circle" :style="[{'color': `var(--${color})`}]">
      <span class="font_text_Arial_BoldMT progress-circle-percent">{{percent}}%</span>
      <svg viewBox="0 0 120 120" class="progress-circle-svg">
        <circle
          cx="60"
          cy="0"
          r="54"
          fill="none"
          stroke="#4e4e4e"
          
          stroke-width="6" />
        
        <circle
          class="progress-circle-line"
          :style="[{'stroke-dashoffset': `calc(100 - ${100})`}]"
          cx="60"
          cy="0"
          r="54"
          fill="none"
          :stroke="`var(--${color})`"
          stroke-width="6"
          pathLength="100" />
      </svg>
    </div>
    
  </template>


<style>


@media (min-width: 0px) and (max-width: 430px){
  .progress-circle {
	position: relative;
	margin-bottom: 10px;
	margin-left: 5px;
	width: 100px;
	height: 100px;
}
.progress-circle-svg{
transform: rotate(180deg);
}
.progress-circle-percent {
position: absolute;
left: 0;
width: 100%;
top: 0;
height: 100%;
display: flex;
align-items: end;
justify-content: center;
color: var(--primary);
/* // font-weight: bold; */
font-size: 22px;
/* // color: white; */

}
.progress-circle-line {
stroke-dasharray: 100;
transition: .5s;
width: 43px;
height: 58px;
}

}



@media (min-width: 430px) and (max-width: 1300px) {
  .progress-circle {
	position: relative;
	margin-bottom: 10px;
	margin-left: 20px;
	width: 73px;
	height: 73px;
}
.progress-circle-svg{
transform: rotate(180deg);
}
.progress-circle-percent {
position: absolute;
left: 0;
width: 100%;
top: 0;
height: 100%;
display: flex;
align-items: end;
justify-content: center;
color: var(--primary);
/* // font-weight: bold; */
font-size: 19px;
/* // color: white; */

}
.progress-circle-line {
stroke-dasharray: 100;
transition: .5s;
width: 43px;
height: 58px;
}
.diogram_fact_plan {
	margin-top: -10px
  }


}

</style>